var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.461,
    height: 25.5,
    viewBox: "0 0 21.461 25.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-33.908)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(33.908 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M55.342,6.564c-.03-.671-.03-1.311-.03-1.952A.9.9,0,0,0,54.4,3.7,12.252,12.252,0,0,1,45.279.252.941.941,0,0,0,44,.252,12.252,12.252,0,0,1,34.881,3.7a.9.9,0,0,0-.915.915c0,.64,0,1.281-.03,1.952-.122,6.4-.3,15.186,10.4,18.875l.3.061.3-.061C55.616,21.749,55.464,13,55.342,6.564ZM43.907,15.437a.984.984,0,0,1-.64.244h-.03a.858.858,0,0,1-.64-.3L39.76,12.235l1.372-1.22,2.226,2.47,4.94-4.7,1.25,1.342Z",
    transform: "translate(-33.908 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield);
export default __webpack_public_path__ + "static/media/shield.fcdbcc5c6ec886e47c1cbdddc4e1e945.svg";
export { ForwardRef as ReactComponent };